const selectedItemsList = {
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: '680px',
  gap: '5px',
  marginTop: '10px',
};

export { selectedItemsList };
